"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../styles");
var Product = function (props) {
    return (react_1.default.createElement("a", __assign({}, props, { target: "_blank" }), props.children));
};
var StyledProduct = (0, styled_components_1.default)(Product)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-basis: 21%;\n    margin-bottom: 60px;\n    color: black;\n    text-decoration: none;\n    min-width: 150px;\n\n    &:hover {\n        color: black;\n    }\n\n    img {\n        max-width: 100%;\n        margin-bottom: 30px;\n    }\n\n    ", " {\n        text-align: center;\n    }\n\n    @media (max-width: 480px) {\n        flex-basis: 100%;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-basis: 21%;\n    margin-bottom: 60px;\n    color: black;\n    text-decoration: none;\n    min-width: 150px;\n\n    &:hover {\n        color: black;\n    }\n\n    img {\n        max-width: 100%;\n        margin-bottom: 30px;\n    }\n\n    ", " {\n        text-align: center;\n    }\n\n    @media (max-width: 480px) {\n        flex-basis: 100%;\n    }\n"])), styles_1.LabelTitle);
exports.default = StyledProduct;
var templateObject_1;
